import React from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames';

import css from './IconArrow.module.css';

const DIRECTION_RIGHT = 'right';
const DIRECTION_LEFT = 'left';
const DIRECTION_DOWN = 'down';
const DIRECTION_UP = 'up';
const DIRECTION_45 = '45';
const SIZE_BIG = 'big';
const SIZE_SMALL = 'small';

const IconArrowHead = ({
  className = '',
  rootClassName = '',
  direction,
  size = SIZE_SMALL,
  isDisabled,
}) => {
  const classes = classNames(rootClassName || css.root, className, {
    [css.disabled]: isDisabled,
  });

  const isRight = direction === DIRECTION_RIGHT;
  const isLeft = direction === DIRECTION_LEFT;
  const isDown = direction === DIRECTION_DOWN;
  const isUp = direction === DIRECTION_UP;
  const is45 = direction === DIRECTION_45;
  const isBig = size === SIZE_BIG;
  const isSmall = size === SIZE_SMALL;

  if (isRight && isSmall) {
    return (
      <svg
        className={classes}
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          strokeWidth={0.25}
          d="M11.0515 5.92924L6.57574 1.45351L7.42426 0.60498L12.9243 6.10498L13.2968 6.4775L12.9756 6.89507L7.97557 13.3951L7.02443 12.6634L11.2815 7.12924H0V5.92924H11.0515Z"
          fill="#00D563"
        />
      </svg>
    );
  } else if (isLeft && isSmall) {
    return (
      <svg
        className={classes}
        width="9"
        height="13"
        viewBox="0 0 9 13"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.195 6.03c-.26.26-.26.68 0 .94l5.333 5.335c.262.26.683.26.943 0 .262-.26.262-.683 0-.943L2.61 6.5l4.86-4.862c.262-.26.262-.683 0-.943-.26-.26-.68-.26-.942 0L1.195 6.03z"
          fillRule="evenodd"
        />
      </svg>
    );
  } else if (isDown && isSmall) {
    return (
      <svg
        className={classes}
        width="13"
        height="9"
        viewBox="0 0 13 9"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.03 6.805c.26.26.68.26.94 0l5.335-5.333a.668.668 0 0 0-.943-.943L6.5 5.39 1.638.53a.666.666 0 1 0-.943.942L6.03 6.805z"
          fillRule="evenodd"
        />
      </svg>
    );
  } else if (isUp && isSmall) {
    return (
      <svg
        className={classes}
        width="13"
        height="9"
        viewBox="0 0 13 9"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.97.195a.664.664 0 0 0-.94 0L.695 5.528a.668.668 0 0 0 .943.943L6.5 1.61l4.862 4.86a.666.666 0 1 0 .943-.942L6.97.195z"
          fillRule="evenodd"
        />
      </svg>
    );
  } else if (isRight && isBig) {
    return (
      <svg
        className={classNames(classes, css.right)}
        width="42"
        height="42"
        viewBox="0 0 61 61"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="30.1008"
          cy="30.1008"
          r="29.1558"
          transform="matrix(-1 0 0 1 60.2017 0)"
        />
        <path d="M41.6754 31.8501H22.6368L30.9545 40.3855C31.6192 41.0677 31.6192 42.1871 30.9545 42.8692C30.2897 43.5513 29.2159 43.5513 28.5512 42.8692L17.3189 31.3429C16.6542 30.6607 16.6542 29.5588 17.3189 28.8767L28.5342 17.3329C29.1989 16.6508 30.2727 16.6508 30.9374 17.3329C31.6022 18.015 31.6022 19.1169 30.9374 19.7991L22.6368 28.352H41.6754C42.6129 28.352 43.3799 29.1391 43.3799 30.101C43.3799 31.063 42.6129 31.8501 41.6754 31.8501Z" />
      </svg>
    );
  } else if (isLeft && isBig) {
    return (
      <svg
        className={classes}
        width="42"
        height="42"
        viewBox="0 0 61 61"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="30.1008"
          cy="30.1008"
          r="29.1558"
          transform="matrix(-1 0 0 1 60.2017 0)"
        />
        <path d="M41.6754 31.8501H22.6368L30.9545 40.3855C31.6192 41.0677 31.6192 42.1871 30.9545 42.8692C30.2897 43.5513 29.2159 43.5513 28.5512 42.8692L17.3189 31.3429C16.6542 30.6607 16.6542 29.5588 17.3189 28.8767L28.5342 17.3329C29.1989 16.6508 30.2727 16.6508 30.9374 17.3329C31.6022 18.015 31.6022 19.1169 30.9374 19.7991L22.6368 28.352H41.6754C42.6129 28.352 43.3799 29.1391 43.3799 30.101C43.3799 31.063 42.6129 31.8501 41.6754 31.8501Z" />
      </svg>
    );
  } else if (isDown && isBig) {
    return (
      <svg
        className={classes}
        width="15"
        height="11"
        viewBox="0 0 15 11"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M.5 1.1C.5.93.565.76.692.642a.508.508 0 0 1 .764.07L7 7.972 12.545.71a.506.506 0 0 1 .763-.07c.23.214.257.592.064.846l-5.958 7.8A.524.524 0 0 1 7 9.498a.522.522 0 0 1-.414-.212l-5.958-7.8A.638.638 0 0 1 .5 1.098"
          fillRule="evenodd"
        />
      </svg>
    );
  } else if (isUp && isBig) {
    return (
      <svg
        className={classes}
        width="15"
        height="11"
        viewBox="0 0 15 11"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5 8.9c0 .17-.065.34-.192.458a.508.508 0 0 1-.764-.07L7 2.028 1.455 9.29a.506.506 0 0 1-.763.07.644.644 0 0 1-.064-.846l5.958-7.8A.524.524 0 0 1 7 .502c.16 0 .31.077.414.212l5.958 7.8c.086.113.128.25.128.388"
          fillRule="evenodd"
        />
      </svg>
    );
  } else if (is45 && isBig) {
    return (
      <svg
        className={classNames(classes, css.angle45)}
        width="42"
        height="42"
        viewBox="0 0 74 74"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M54.9405 18.3135C65.0548 28.4278 65.0548 44.8262 54.9405 54.9405C44.8262 65.0548 28.4278 65.0548 18.3135 54.9405C8.19924 44.8263 8.19924 28.4278 18.3135 18.3135C28.4278 8.19924 44.8262 8.19924 54.9405 18.3135Z"
          fill="#00D563"
        />
        <path
          d="M30.6489 44.7334L42.2321 33.1502L42.3646 43.4037C42.3752 44.2232 43.0562 44.9042 43.8757 44.9148C44.6951 44.9254 45.3484 44.2721 45.3378 43.4526L45.1589 29.6061C45.1484 28.7867 44.4779 28.1163 43.6585 28.1057L29.8117 27.9058C28.9923 27.8952 28.339 28.5485 28.3496 29.368C28.3602 30.1874 29.0306 30.8578 29.85 30.8684L40.1038 31.0219L28.5206 42.6051C27.9503 43.1755 27.9625 44.121 28.5477 44.7063C29.133 45.2915 30.0785 45.3038 30.6489 44.7334Z"
          fill="white"
        />
      </svg>
    );
  }
};

IconArrowHead.propTypes = {
  className: string,
  rootClassName: string,
  direction: oneOf([
    DIRECTION_RIGHT,
    DIRECTION_LEFT,
    DIRECTION_DOWN,
    DIRECTION_UP,
    DIRECTION_45,
  ]).isRequired,
  size: oneOf([SIZE_BIG, SIZE_SMALL]),
};

export default IconArrowHead;
